import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { orderDetailsAPI } from 'src/app/services/apiRoutes';
import { PaginationObject } from 'src/app/models/paginationObject';
import paginationHelper from 'src/app/helpers/pagination';
import sortHelper from 'src/app/helpers/sort';
import { SortObject } from 'src/app/models/sortObject';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class OrdersService {

  private readonly ordersDashboard = new BehaviorSubject(false);
  ordersDashboardData = this.ordersDashboard.asObservable();

  constructor(public http: HttpClient) { }

  async getOrders(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        orderDetailsAPI +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true) +
        query
      )
      .toPromise();
  }

  fetchOrdersDashboard(fetchOrders: boolean) {
    this.ordersDashboard.next(fetchOrders)
  }

}
